const SEARCH_INPUT_HOOK = '[js-hook-form-autocomplete]';

class generalSearchBar {
    constructor(element) {
        this.element = element;
        this.searchInput = element.querySelector(SEARCH_INPUT_HOOK);
        this.qs = require('qs');

        this.bindEvents();

        this.init();
    }

    /**
     * Bind all events
     */
    bindEvents() {}

    init() {
        //set search parameter as value in search input field

        const searchUrl = window.location.search;
        const queryParams = this.qs.parse(searchUrl, { ignoreQueryPrefix: true });

        const searchQuery = queryParams.search;

        if (searchQuery !== undefined) {
            this.searchInput.value = searchQuery;
        }
    }
}

export default generalSearchBar;
